import Timestamp from "components/Timestamp";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Session } from "types/generated";

const SessionsTableCreatedAtCell = ({
  item: session,
  ...cellProps
}: TableSimpleCellProps<Pick<Session, "createdAt">>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <Timestamp variant="p-body3" timestamp={session.createdAt} />
    </TableSimpleCell>
  );
};

export default SessionsTableCreatedAtCell;
